var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroProjectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_86_4",
    "data-name": "Component 86 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52.002,
    viewBox: "0 0 52 52.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7310",
    d: "M11.891,280.6a7.218,7.218,0,0,0-7.258,7.26V290.9H9.227v-3.046a2.611,2.611,0,0,1,2.664-2.666H16.41a2.613,2.613,0,0,1,2.666,2.666V290.9h4.594v-3.046a7.3,7.3,0,0,0-7.26-7.26Z",
    transform: "translate(11.804 -279.942)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7314",
    d: "M4.631,283.721v2.552H9.225v-2.552Zm14.442,0v2.552h4.594v-2.552Z",
    transform: "translate(11.807 -272.842)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7308",
    d: "M4.748,284.609H46.934c2.337,0,4.219,1.464,4.219,3.282v22.866c0,1.818-1.881,3.282-4.219,3.282H4.748c-2.337,0-4.219-1.464-4.219-3.282V287.891c0-1.818,1.881-3.282,4.219-3.282Z",
    transform: "translate(0.129 -262.763)",
    fill: "#a0694c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7312",
    d: "M4.748,284.609c-2.337,0-4.219,1.464-4.219,3.282v6.448c0,5.336,5.521,9.633,12.379,9.633H38.773c6.858,0,12.379-4.3,12.379-9.633v-6.448c0-1.818-1.881-3.282-4.219-3.282Z",
    transform: "translate(0.129 -268.428)",
    fill: "#ffc861"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7332",
    d: "M7.342,284.609v17.8h5.58v-17.8Z",
    transform: "translate(15.828 -268.807)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7505",
    d: "M34.276,288.531a9.629,9.629,0,0,1-8.675,9.584c-.315.031-.633.049-.957.049H18.11v2.272a1.719,1.719,0,0,1-1.723,1.723H13.729a1.314,1.314,0,0,0,1.112,2.012h1.571c2.163,0,3.724-1.345,3.743-3.9h4.694a11.758,11.758,0,0,0,9.428-4.943ZM4.607,298.164a1.313,1.313,0,0,0,1.076,2.105h5.371v-2.105Z",
    transform: "translate(17.005 -256.954)",
    fill: "#8f4e40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7343",
    d: "M9.464,290.336a1.318,1.318,0,0,0-1.074,2.092h2.344a1.713,1.713,0,0,1,.985.31v-2.4Z",
    transform: "translate(17.337 -258.247)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7334",
    d: "M8.768,291.179h3.611A1.719,1.719,0,0,1,14.1,292.9v3.611a1.719,1.719,0,0,1-1.723,1.723H8.768a1.719,1.719,0,0,1-1.723-1.723V292.9A1.719,1.719,0,0,1,8.768,291.179Z",
    transform: "translate(15.386 -255.297)",
    fill: "#d1dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7354",
    d: "M9.481,293.1a1.313,1.313,0,0,0-.868,2.3h2.1a1.719,1.719,0,0,0,1.723-1.723V293.1Z",
    transform: "translate(17.484 -252.175)",
    fill: "#bfd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7341",
    d: "M29.154.266q-2.886,0-5.771,0A10.052,10.052,0,0,0,13.272,10.4v2.582H5.3A5.041,5.041,0,0,0,.264,18.016V47.233A5.043,5.043,0,0,0,5.3,52.267h41.94a5.036,5.036,0,0,0,5.026-5.034V18.016a5.034,5.034,0,0,0-5.026-5.032H39.269V10.376A10.162,10.162,0,0,0,29.154.266ZM23.383,1.943h5.771a8.477,8.477,0,0,1,8.438,8.433v2.608H33.4V10.378a4.222,4.222,0,0,0-4.246-4.241H23.383a4.218,4.218,0,0,0-4.241,4.241.839.839,0,1,0,1.677,0,2.451,2.451,0,0,1,2.564-2.564h5.771a2.455,2.455,0,0,1,2.569,2.564v2.606H14.95V10.378c0-.01,0-.017,0-.026A8.384,8.384,0,0,1,23.383,1.943ZM5.3,14.661H21.866v20a3.024,3.024,0,0,0-.947,2.19v4.613A3.049,3.049,0,0,0,23.958,44.5H28.57a3.057,3.057,0,0,0,3.047-3.039V36.851a3.024,3.024,0,0,0-.948-2.189v-20H47.238a3.324,3.324,0,0,1,3.348,3.355v8.241A11.422,11.422,0,0,1,39.121,37.724h-4.7a.839.839,0,1,0,0,1.677h4.7A13.123,13.123,0,0,0,50.587,32.68V47.233a3.325,3.325,0,0,1-3.348,3.356H5.3a3.332,3.332,0,0,1-3.356-3.356V32.677A13.123,13.123,0,0,0,13.408,39.4h4.711a.839.839,0,0,0,0-1.677H13.408A11.423,11.423,0,0,1,1.941,26.257V18.016A3.331,3.331,0,0,1,5.3,14.661Zm18.245,0h5.448V33.853H23.543Zm.414,20.827H28.57a1.347,1.347,0,0,1,1.369,1.363v4.613a1.351,1.351,0,0,1-1.369,1.368H23.958A1.345,1.345,0,0,1,22.6,41.464V36.851A1.341,1.341,0,0,1,23.958,35.488Z",
    transform: "translate(-0.264 -0.265)",
    fill: "#00003a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroProjectIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroProjectIcon.05ae61748ad3d263e56a9a5ccd89f186.svg";
export { ForwardRef as ReactComponent };